<template>
	<div class="container mt-4 px-2">
		<div class="cards-grid">
			<router-link :to="{ name: 'scan' }" class="dashboard-card scan-card">
				<div class="card-icon">
					<i class="fas fa-camera"></i>
				</div>
				<div class="card-content">
					<h3 class="card-title">Scanner</h3>
					<p>Numériser une note de frais</p>
				</div>
			</router-link>
			<div></div>
		</div>
		<div class="dashboard-section mt-4">
			<div class="section-header d-flex justify-content-between align-items-center flex-wrap gap-2">
				<h2 class="section-title"><i class="fas fa-receipt"></i> Mes notes de frais</h2>
				<n-date-picker v-model:value="params.date" type="month" input-readonly class="date-picker"/>
			</div>
			<n-card class="expense-card">
				<!-- Desktop: Tabs navigation -->
				<n-tabs
					v-if="!isMobile"
					type="line"
					animated
					:value="params.category"
					@update:value="params.category = $event"
					class="desktop-tabs"
					justify-content="start"
				>
					<n-tab-pane name="all" tab="Toutes"/>
					<n-tab-pane
						v-for="category in categories"
						:key="category"
						:name="category"
						:tab="libelle(category)"
					/>
				</n-tabs>
				
				<!-- Mobile: Select dropdown -->
				<div v-if="isMobile" class="mobile-category-select mb-3">
					<n-select
						:value="params.category"
						@update:value="params.category = $event"
						:options="categoryOptions"
						size="medium"
						placeholder="Sélectionner une catégorie"
					/>
				</div>
				<div class="expenses-list mt-4" :dummy="force_react_expenses">
					<template v-if="expenses.length">
						<n-list hoverable clickable class="responsive-list">
							<n-list-item
								v-for="expense in expenses"
								:key="expense.id"
								@click="displayExpense(expense)"
								class="expense-item"
							>
								<n-thing>
									<template #avatar>
										<img
											v-if="!isPdf(expense)"
											:src="getPb.files.getUrl(expense, expense.picture, {'thumb': '100x100'})"
											alt="ticket"
											class="expense-thumbnail"
										>
										<span v-else class="expense-thumbnail d-flex align-items-center justify-content-center text-danger">
											<i class="far fa-file-pdf fa-2x"></i>
										</span>
									</template>
									<template #header>
										<div class="d-flex justify-content-between align-items-center flex-wrap">
											<div class="expense-header">
												<span v-if="params.category !== 'fuel'"
													  class="supplier-name">{{ expense.supplier }} - {{ price(expense.totalttc) }}</span>
											</div>
										</div>
									</template>
									<template #description>
										<div class="text-muted">
											<i class="fa fa-calendar me-1"></i> {{ formatDate(expense.date) }}
											<span v-if="expense.exported_at" class="ms-2">
												<i class="far fa-file-invoice me-1"></i> Exporté le
												{{ formatDate(expense.exported_at) }}
											</span>
										</div>
										<n-space size="small" style="margin-top: 4px">
											<n-tag v-if="expense.exported_at" type="success" class="status-tag">
												<i class="fas fa-check me-1"></i>
												En compta
											</n-tag>
											<n-tag v-else type="info" class="status-tag">
												<i class="fas fa-clock me-1"></i>
												En attente
											</n-tag>
										</n-space>
									</template>
								</n-thing>
							</n-list-item>
						</n-list>
					</template>
					<n-empty
						v-else
						description="Aucune note de frais disponible"
					>
						<template #icon>
							<i class="fas fa-receipt text-muted" style="font-size: 2rem;"></i>
						</template>
					</n-empty>
				</div>
			</n-card>
		</div>
	</div>
</template>


<script>
import moment from 'moment';
import {formatDate, formatDateTime, price} from '../../plugins/helpers.js'
import {mapGetters} from "vuex";
import {NSpace, NTag, NSelect} from "naive-ui";


moment.locale('fr');

export default {
	name: 'ExpensesScan',
	components: {NSpace, NTag, NSelect},
	data() {
		return {
			params: {
				category: 'all',
				// timestapmp du mois courant
				date: null,
			},
			expenses: [],
			displayImage: false,
			isMobile: false,
			categories: [
				'fuel',
				'restaurant',
				'restaurantclient',
				'transportation',
				'misc',
			],
		}
	},
	beforeMount: function () {
		const now = new Date();
		const firstDayOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
		this.params.date = firstDayOfMonth.getTime();
		this.checkScreenSize();
		window.addEventListener('resize', this.checkScreenSize);
	},
	
	beforeUnmount: function() {
		window.removeEventListener('resize', this.checkScreenSize);
	},
	computed: {
		...mapGetters(['getPb']),
		// fonction qui force react à réagir, vu qu'on a pas de compuded async
		// mais on aurait peut-être pu utiliser un watch sur les props
		force_react_expenses: function () {
			console.log('force_react_expenses');

			this.getexpenses();
			return [this.params.date, this.params.category];
		},
		
		// Options pour le select mobile
		categoryOptions: function() {
			const options = [
				{ label: 'Toutes', value: 'all' }
			];
			
			this.categories.forEach(category => {
				options.push({
					label: this.libelle(category),
					value: category
				});
			});
			
			return options;
		}

	},
	methods: {

		isPdf(expense) {
			return typeof expense.picture === 'string' && expense.picture.toLowerCase().endsWith('.pdf');
		},

		async getexpenses() {

			const pb = this.getPb;

			const filter =
				pb.filter("user = {:user} && date >= {:startdate} && date <= {:enddate} && deleted = null", {
						user: this.getPb.authStore.model.id,
						startdate: moment(this.params.date).startOf('month').toDate(),
						enddate: moment(this.params.date).endOf('month').toDate()
					}
				);

			const rawExpenses = await pb.collection('expense').getFullList({
				sort: '-date',
				filter: filter
			});

			if (rawExpenses.length === 0) {
				this.expenses = [];
				return;
			}

			if (this.params.category === 'all') {
				console.log('all', rawExpenses);
				this.expenses = rawExpenses;
				return;
			}

			this.expenses = rawExpenses.filter(e => e.category === this.params.category);
			return;

		},

		displayExpense(expense) {
			this.$router.push({name: 'expensesview', params: {id: expense.id}});
		},

		formatDateTime,
		formatDate,
		price,
		libelle(value) {
			switch (value) {
				case 'fuel':
					return 'Carburant';
				case 'restaurant':
					return 'Restaurant Interne';
				case 'restaurantclient':
					return 'Restaurant Client';
				case 'transportation':
					return 'Transport';
				case 'misc':
					return 'Divers';
				default:
					return '';
			}
		},
		
		getShortLabel(value) {
			switch (value) {
				case 'fuel':
					return 'Carburant';
				case 'restaurant':
					return 'Rest. Int.';
				case 'restaurantclient':
					return 'Rest. Client';
				case 'transportation':
					return 'Transport';
				case 'misc':
					return 'Divers';
				default:
					return '';
			}
		},
		
		checkScreenSize() {
			this.isMobile = window.innerWidth < 768;
		}
	}
}
</script>


<style scoped>
.expense-thumbnail {
	width: 60px;
	height: 60px;
	object-fit: cover;
	border-radius: 4px;
}

.supplier-name {
	font-weight: 500;
	word-break: break-word;
}

.amount {
	font-weight: 600;
	color: #2080f0;
}

/* Responsive styles */
.section-title {
	font-size: 1.5rem;
	margin-bottom: 0;
}

.card-title {
	font-size: 1.25rem;
}

.expense-header {
	max-width: 100%;
}

.expense-card {
	overflow: hidden;
}

/* Mobile category select */
.mobile-category-select {
	width: 100%;
}

/* Mobile styles */
@media (max-width: 768px) {
	.section-title {
		font-size: 1.25rem;
		margin-right: auto;
	}
	
	.expense-thumbnail {
		width: 50px;
		height: 50px;
	}
	
	.supplier-name {
		font-size: 0.9rem;
	}
	
	.expense-item :deep(.n-thing-main) {
		padding-left: 0.5rem;
	}
	
	:deep(.n-thing-avatar) {
		margin-right: 8px;
	}
	
	:deep(.n-list-item__content) {
		padding: 8px 12px;
	}
	
	:deep(.n-card__content) {
		padding: 12px;
	}
	
	.date-picker :deep(.n-input) {
		width: auto;
		min-width: 120px;
	}
	
	.mobile-category-select :deep(.n-base-selection) {
		font-size: 0.9rem;
	}
	
	.mobile-category-select :deep(.n-base-selection-label) {
		padding: 0 12px;
	}
}
</style>